export const SET_OPEN_SUPPORT_DIALOG = 'drawer/SET_OPEN_SUPPORT_DIALOG';
export const SET_PLAN_INFO = 'drawer/SET_PLAN_INFO';
export const SET_SUBSCRIPTION_INFO = 'drawer/SET_SUBSCRIPTION_INFO';
export const SET_ACCOUNT_USAGE = 'drawer/SET_ACCOUNT_USAGE';
// Note: billing is now in the billing slice (state.billing), use setBilling from billing/actions
export const SET_UPGRADE_POPUP = 'drawer/SET_UPGRADE_POPUP';
export const SET_RECHARGE_POPUP = 'drawer/SET_RECHARGE_POPUP';
export const REFRESH_PLAN_INFO = 'drawer/REFRESH_PLAN_INFO';
